import PropTypes from "prop-types";
import ErrorBanner from "../../../containers/common/ErrorBanner";
import PageLoadError from "../../../containers/common/PageLoadError";
import Portal from "../Portal";
import isAppOnline from "../../../../providers/applicationOnlineStatusProvider";
import global from "global";

const SavedLists = ({
  initialisationFailure,
  loadingDataOnPageLoad,
  TitleComponent,
  ItemsComponent,
  BannersComponent,
  itemCount,
  children
}) => (
  <>
    <ErrorBanner />
    {initialisationFailure || !isAppOnline ? (
      <PageLoadError isAppOnline={isAppOnline()}>{children}</PageLoadError>
    ) : loadingDataOnPageLoad === false ? (
      <>
        {itemCount !== 0 && <TitleComponent />}
        <ItemsComponent />
      </>
    ) : null}
    <Portal root={global.document.querySelector("body")}>
      <BannersComponent />
    </Portal>
  </>
);

SavedLists.propTypes = {
  initialisationFailure: PropTypes.bool,
  loadingDataOnPageLoad: PropTypes.bool,
  itemCount: PropTypes.number.isRequired,
  TitleComponent: PropTypes.elementType.isRequired,
  ItemsComponent: PropTypes.elementType.isRequired,
  BannersComponent: PropTypes.elementType.isRequired,
  children: PropTypes.node.isRequired
};

export default SavedLists;
